// extracted by mini-css-extract-plugin
module.exports = {"backTop":"primary-layout_backTop__ZdVQM","backTopHome":"primary-layout_backTopHome__WCxxr"};